/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RmaIntakeDetailsDto { 
    batteryTypeId?: string;
    internalDropOff?: RmaIntakeDetailsDto.InternalDropOffEnum;
    externalDropOff?: RmaIntakeDetailsDto.ExternalDropOffEnum;
}
export namespace RmaIntakeDetailsDto {
    export const InternalDropOffEnum = {
        Fired: 'FIRED',
        NotFired: 'NOT_FIRED'
    } as const;
    export type InternalDropOffEnum = typeof InternalDropOffEnum[keyof typeof InternalDropOffEnum];
    export const ExternalDropOffEnum = {
        Fired: 'FIRED',
        NotFired: 'NOT_FIRED'
    } as const;
    export type ExternalDropOffEnum = typeof ExternalDropOffEnum[keyof typeof ExternalDropOffEnum];
}


